// Contato da TI.Fire, usado na landing page (Home) e no "Acessar plataforma"

export const TELEFONE = '(44) 3023-7230';
export const LINK_TELEFONE = 'tel:+554430237230';
export const LINK_WHATSAPP = `https://api.whatsapp.com/send?phone=554430237230&text=${encodeURIComponent('Olá! Tenho interesse no SigepeWeb.')}`;
export const EMAIL = 'contato@tifire.com';
export const ENDERECO = 'Rua Pioneira Maria Josefa de Araújo, 206 - Jd. Novo Horizonte';
export const CIDADE = 'Maringá - PR';
export const SITE = 'https://tifire.com/';
export const LOGO = 'https://tifire.com/assets/img/fogo2.png';
